import './index.styl';
import { View } from 'backbone.marionette';
import template from './index.jst';

export class EmptyPlayerPoolView extends View {
	get template() {
		return template;
	}

	get className() {
		return 'player-pool-item-not-found';
	}

	get tagName() {
		return 'li';
	}
}

export default EmptyPlayerPoolView;